<template>
    <table>
        <thead>
            <tr>
                <th>Tipo</th>
                <th>Especificación</th>
                <th>Descripción</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Other</td>
                <td>Authorization</td>
                <td>Token de administración de identidad y de acceso</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>SESSIONID</td>
                <td>Identificador de la sesión</td>
            </tr>
            <tr>
                <td>Response Content Type</td>
                <td>application/json</td>
                <td>Formato de la respuesta</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>CHANNEL</td>
                <td>Identificador del canal en el que se está operando. 001 = WEB; 003 = Mobile</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>APPID</td>
                <td>Determina el identificador del componente a través del que se está operando. OLB = Online Banking; BANCOS = Módulo Administrativo.</td>
            </tr>
            <tr>
                <td>Authentication</td>
                <td>clientIp</td>
                <td>Dirección IP del usuario que está operando</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>CORRELATIONID</td>
                <td>Identificador de correlación para identificar operaciones dentro de la misma sesión</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>METADATA</td>
                <td>Parámetro que indica de qué manera estructurar la respuesta basada en la configuración de metadata para un servicio determinado.    
                </td>
            </tr>
            <tr>
                <td>Other</td>
                <td>LANG</td>
                <td>Lenguaje en el que se quiere consumir el servicio. ES = Español; EN = Inglés.</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>BANKID</td>
                <td>ID del banco de cabecera asociado al grupo</td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    name: 'Headers'
}
</script>
<style lang="css" scoped>
    table {
        margin: 0px;
    }
    table tr td:nth-child(1) {
        width: 10% !important;
    }
    table tr td:nth-child(2) {
        width: 10% !important;
    }
    table tr td:nth-child(3) {
        width: 30% !important;
    }
</style>